@if (pageLoading || exportLoader) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">
		@if (exportLoader) {
		Generating PDF...
		}@else {
		Loading...
		}
	</p>
</div>
}
<div class="card">
	<div class="card-header bg-theme mb-0">
		<h5 class="card-title text-light mb-0">
			@if(!isAll){
			<strong>
				@if(view == CalendarView.Week){
				{{ viewDate | calendarDate:'weekViewTitle':'en':1 }}
				}@else {
				{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
				}
			</strong>
			}
			@if(!isAll){
			<div class="btn-group float-end ms-2">
				<button class="btn btn-sm btn-light" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
					(viewDateChange)="refreshCalendar()" matTooltip="Previous">
					<fa-icon [icon]="['fas','long-arrow-alt-left']"></fa-icon>
				</button>
				<button class="btn btn-sm btn-secondary" mwlCalendarToday [(viewDate)]="viewDate"
					(viewDateChange)="refreshCalendar()">
					Today
				</button>
				<button class="btn btn-sm btn-light" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
					(viewDateChange)="refreshCalendar()" matTooltip="Next">
					<fa-icon [icon]="['fas','long-arrow-alt-right']"></fa-icon>
				</button>
			</div>
			}
			<div class="btn-group float-end">
				@if (navbar.hasAttendanceAccess()){
				<button class="btn btn-sm btn-secondary" (click)="setViewAllAttendance()" [class.active]="isAll">
					Team Attendance
				</button>
				}
				<button class="btn btn-sm btn-secondary" (click)="setView(CalendarView.Month)"
					[class.active]="!isAll && view === CalendarView.Month">
					Personal Attendance
				</button>
				@if (navbar.hasRosterAccess() || navbar.user?.department){
				<button class="btn btn-sm btn-secondary" (click)="setView(CalendarView.Week)"
					[class.active]="!isAll && view === CalendarView.Week">
					Roster
				</button>
				}
			</div>
		</h5>
	</div>
	<div class="card-body p-2">
		@if(isAll){
		<div class="row g-1 align-items-center mb-2">
			<div class="col-auto" style="width: 110px;">
				<div class="ng-select-default">
					<ng-select [items]="yearList" bindValue="value" bindLabel="name" [clearable]="true"
						placeholder="Year" [(ngModel)]="filters.year" id="year" (change)="refreshCalendar()"
						appearance="outline">
					</ng-select>
				</div>
			</div>
			<div class="col-auto" style="width: 110px;">
				<div class="ng-select-default">
					<ng-select [items]="monthList" bindValue="value" bindLabel="name" [clearable]="true"
						placeholder="Month" [(ngModel)]="filters.month" id="month" (change)="refreshCalendar()"
						appearance="outline">
					</ng-select>
				</div>
			</div>
			<div class="col">
				<div class="ng-select-default">
					<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name" placeholder="Department"
						[(ngModel)]="filters.department" id="department" (change)="refreshCalendar();"
						appearance="outline" class="bottom-margin" [multiple]="true" [disabled]="disableDepartment">
					</ng-select>
				</div>
			</div>
			<div class="col-auto">
				@if(allAttendance.length){
				<button class="btn btn-sm btn-primary h-100 ms-1" matTooltip="Excel" [matTooltipPosition]="'below'"
					(click)="getAttendanceAllExcel()" [disabled]="excelLoader">
					@if (excelLoader) {
					<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas', 'cloud-download-alt']"></fa-icon>
					}
					Attendance
				</button>
				<button class="btn btn-sm btn-success h-100 ms-1" matTooltip="Excel" [matTooltipPosition]="'below'"
					(click)="getTimesheetAllExcel()" [disabled]="timesheetLoader">
					@if (timesheetLoader) {
					<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas', 'cloud-download-alt']"></fa-icon>
					}
					Timesheet
				</button>
				}
			</div>
		</div>
		<div class="row g-0">
			<div class="col">
				@for (item of allAttendance; track $index) {
				<table class="table table-bordered attendance-table mb-0">
					<thead>
						<tr>
							<th style="width: 10%;">
								Emp. Code:
								{{item.emp_code}}
							</th>
							<th style="width: 20%;">
								Name:
								{{item.first_name}} {{item.last_name}}
							</th>
							<th style="width: 10%;" class="text-present">
								Present:
								{{item.present_count}}
							</th>
							<th style="width: 10%;" class="text-half-present">
								Half Day:
								{{item.half_present_count}}
							</th>
							<th style="width: 10%;" class="text-weekly-off">
								<span matTooltip="Weekly off">
									WO:
									{{item.WO_count}}
								</span>
							</th>
							<th style="width: 10%;" class="text-weekly-off">
								<span matTooltip="Leaves">
									LV:
									{{item.LV_count}}
								</span>
							</th>
							<th style="width: 10%;" class="text-absent">
								Absent:
								{{item.absent_count}}
							</th>
							<th style="width: 10%;">
								Total Work:
								{{item.work_time}}
							</th>
							<th style="width: 10%;">
								<span matTooltip="Leave Balance">
									LB:
									{{item.leave_balance}}
								</span>
							</th>
						</tr>
					</thead>
				</table>
				<table class="table table-bordered attendance-table table-hover">
					<tbody>
						<tr>
							<td class="heading"></td>
							@for (attnd of item.attendance; track $index) {
							<td class="data">
								{{attnd.dispDate}}
							</td>
							}
						</tr>
						<tr>
							<td class="heading"></td>
							@for (attnd of item.attendance; track $index) {
							<td class="data">
								{{attnd.dispDay}}
							</td>
							}
						</tr>
						<tr>
							<td class="heading">In</td>
							@for (attnd of item.attendance; track $index) {
							<td class="data">
								{{attnd.in_time || "--:--"}}
							</td>
							}
						</tr>
						<tr>
							<td class="heading">Out</td>
							@for (attnd of item.attendance; track $index) {
							<td class="data">
								{{attnd.out_time || "--:--"}}
							</td>
							}
						</tr>
						<tr>
							<td class="heading">Work</td>
							@for (attnd of item.attendance; track $index) {
							<td class="data">
								{{attnd.work_time}}
							</td>
							}
						</tr>
						<tr>
							<td class="heading">Status</td>
							@for (attnd of item.attendance; track $index) {
							<td [ngClass]="getClass(attnd)">
								{{attnd.status}}
							</td>
							}
						</tr>
					</tbody>
				</table>
				}@empty {
				<h3 class="text-center">No data found</h3>
				}
			</div>
		</div>
		}@else{
		<ng-container [ngSwitch]="view">
			<div class="row">
				<ng-container *ngSwitchCase="CalendarView.Month">
					<div [ngClass]="navbar.hasRegularizationAccess() || navbar.hasLeaveAccess() ? 'col-9' : 'col-12'">
						<div class="row g-0">
							<div class="col-3">
								@if (navbar.hasAttendanceAccess()){
								<div class="ng-select-default">
									<ng-select [items]="allUserList" bindValue="emp_code" bindLabel="full_name"
										[clearable]="true" placeholder="Employee" [(ngModel)]="filters.emp_code"
										id="emp_code" (change)="refreshCalendar()" appearance="outline"
										[groupBy]="'department_name'" [disabled]="isAssignee">
									</ng-select>
								</div>
								}
							</div>
							<div class="col-9">
								@if(filters.emp_code){
								<span class="me-2 ms-3 badge bg-present text-light">
									Present Days:
									<strong>{{present_days}}</strong>
								</span>
								<span class="me-2 badge bg-absent text-light">
									Absent Days:
									<strong>{{absent_days}}</strong>
								</span>
								<span class="me-2 badge bg-present text-light">
									Working Hours:
									<strong>{{working_hrs}}</strong>
								</span>
								<span class="me-2 badge bg-weekly-off text-light" role="button"
									(click)="changeLeaveBal(filters.emp_code,leave_balance)">
									Leave Balance:
									<strong>{{leave_balance}}</strong>
								</span>
								<span class="me-2 badge bg-success text-light" matTooltip="Total Events">
									<fa-icon [icon]="['fas','trophy']"></fa-icon>
									:
									<strong>{{total_events}}</strong>
								</span>
								}
								<button class="btn btn-xs btn-secondary float-end" (click)="createLeave()">
									Apply Leave
								</button>
							</div>
						</div>
						<mwl-calendar-month-view #calendarMonthViewComponent [viewDate]="viewDate" [events]="events"
							[refresh]="refresh" [weekendDays]="[0,6]" [weekStartsOn]="1" [cellTemplate]="cellTemplate">
						</mwl-calendar-month-view>
					</div>
					@if (navbar.hasRegularizationAccess() || navbar.hasLeaveAccess()) {
					<div class="col-3">
						<div class="card mb-1">
							<div class="card-body px-2 py-1">
								<div class="input-group input-group-sm">
									<span class="input-group-text">
										<fa-icon [icon]="['fas', 'search']"></fa-icon>
									</span>
									<input type="text" class="form-control" placeholder="Search by name, date, etc..."
										[(ngModel)]="searchQuery" />
								</div>
							</div>
						</div>
						@if(navbar.hasRegularizationAccess()){
						<div class="card mb-1">
							<div class="card-header py-0 px-1 my-0">
								<h5 class="card-title mb-0 text-center">
									Regularization Requests
								</h5>
							</div>
							<div class="card-body px-2 py-1 regularization-list">
								@for (v of filteredRegularizationList; track $index) {
								<div class="card card-body p-2">
									<div class="row g-0">
										<div class="col">
											<h5 class="fw-bold mb-0">
												{{ v.emp_code?.first_name }} {{ v.emp_code?.last_name }}
											</h5>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											<p class="mb-0">
												<strong>In:&nbsp;&nbsp;&nbsp;</strong>
												{{ v.in_date }} {{ v.in_time }}
											</p>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											<p class="mb-0">
												<strong>Out:</strong>
												{{ v.out_date }} {{ v.out_time }}
											</p>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											@if (v.is_approved) {
											<span class="badge bg-success text-light">
												Approved
											</span>
											} @else if(navbar.hasRegularizationAccess() && !isAssignee) {
											<button class="btn btn-xs btn-warning" matTooltip="Approve"
												(click)="approveRegRequest(v.id)">
												@if (showApproveRegLoader === v.id) {
												<fa-icon [icon]="['fas', 'spinner']" animation="spin">
												</fa-icon>
												}@else {
												<fa-icon [icon]="['fas', 'check']">
												</fa-icon>
												}
												Approve
											</button>
											}
											@if (
											(
											navbar.hasRegularizationAccess() ||
											v.emp_code?.emp_code == navbar.user?.emp_code
											) &&
											!v.is_approved
											) {
											<button class="btn btn-xs btn-primary ms-1" matTooltip="Edit"
												(click)="editReg(v)">
												<fa-icon [icon]="['fas', 'edit']"></fa-icon>
											</button>
											<button class="btn btn-xs btn-danger ms-1" matTooltip="Delete"
												(click)="deleteConfirmReg(v.id)">
												@if (showDeleteRegLoader === v.id) {
												<fa-icon [icon]="['fas', 'spinner']" animation="spin">
												</fa-icon>
												}@else {
												<fa-icon [icon]="['fas', 'times']">
												</fa-icon>
												}
											</button>
											}
										</div>
									</div>
								</div>
								}@empty {
								<div class="text-center">
									<img src="../../../assets/img/empty-box.png" class="empty-img"
										alt="No request image" matTooltip="List empty" />
								</div>
								}
							</div>
						</div>
						}
						@if(navbar.hasLeaveAccess()){
						<div class="card mb-0">
							<div class="card-header py-0 px-1 my-0">
								<h5 class="card-title mb-0 text-center">
									Leave Requests
								</h5>
							</div>
							<div class="card-body px-2 py-1 leave-list">
								@for (v of filteredLeaveList; track $index) {
								<div class="card card-body p-2">
									<div class="row g-0">
										<div class="col">
											<h5 class="fw-bold mb-0">
												{{ v.emp_code?.first_name }} {{ v.emp_code?.last_name }}
											</h5>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											<p class="mb-0">
												<strong>From:</strong>
												{{ v.from_date }}
											</p>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											<p class="mb-0">
												<strong>To:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
												{{ v.to_date }}
											</p>
										</div>
									</div>
									<div class="row g-0">
										<div class="col">
											@if (v.is_approved) {
											<span class="badge bg-success text-light">Approved</span>
											} @else if(navbar.hasLeaveAccess() && !isAssignee) {
											<button class="btn btn-xs btn-warning" matTooltip="Approve"
												(click)="approveLeaveRequest(v.id)">
												@if (showApproveLeaveLoader === v.id) {
												<fa-icon [icon]="['fas', 'spinner']" animation="spin">
												</fa-icon>
												}@else {
												<fa-icon [icon]="['fas', 'check']">
												</fa-icon>
												}
												Approve
											</button>
											}
											@if (
											(
											navbar.hasLeaveAccess() ||
											v.emp_code?.emp_code == navbar.user?.emp_code
											) &&
											!v.is_approved
											) {
											<button class="btn btn-xs btn-primary ms-1" matTooltip="Edit"
												(click)="editLeave(v)">
												<fa-icon [icon]="['fas', 'edit']"></fa-icon>
											</button>
											<button class="btn btn-xs btn-danger ms-1" matTooltip="Delete"
												(click)="deleteConfirmLeave(v.id)">
												@if (showDeleteLeaveLoader === v.id) {
												<fa-icon [icon]="['fas', 'spinner']" animation="spin">
												</fa-icon>
												}@else {
												<fa-icon [icon]="['fas', 'times']">
												</fa-icon>
												}
											</button>
											}
										</div>
									</div>
								</div>
								}@empty {
								<div class="text-center">
									<img src="../../../assets/img/empty-box.png" class="empty-img"
										alt="No request image" matTooltip="List empty" />
								</div>
								}
							</div>
						</div>
						}
					</div>
					}
				</ng-container>
				<ng-container *ngSwitchCase="CalendarView.Week">
					<div [ngClass]="navbar.hasRosterAccess() ? 'col-9' : 'col-12'">
						<div class="d-flex justify-content-end mb-2">
							<button id="pdfDownloadBtn" class="btn btn-sm btn-outline-primary" [disabled]="exportLoader"
								(click)="exportToPDF(calendarContainer)">
								<fa-icon [icon]="['fas', 'file-pdf']" class="me-1"></fa-icon>
								Download PDF
							</button>
						</div>
						<div #calendarContainer>
							<div class="px-1 mb-2">
								<span class="fw-bold fs-5 text-dark" id="weekViewTitleDoNotRemove">
									{{ viewDate | calendarDate:'weekViewTitle':'en':1 }}
								</span>
							</div>
							@if (showPdfLegend && rosterLegend && rosterLegend.length > 0) {
							<div class="roster-legend-container mb-3 p-2 border rounded bg-light">
								<div class="fw-bold mb-1 text-dark" style="font-size: 12px;">Roster Legend:</div>
								<div class="d-flex flex-wrap gap-2">
									@for (legendItem of rosterLegend; track $index) {
									<div class="d-flex align-items-center gap-1 border rounded px-2 py-1 bg-white shadow-sm"
										style="font-size: 11px;">
										<span
											class="badge rounded-circle d-inline-flex align-items-center justify-content-center text-white"
											[style.background-color]="legendItem.color"
											style="width: 16px; height: 16px; font-size: 9px;">
											{{ legendItem.initials }}
										</span>
										<span class="fw-semibold text-dark">{{ legendItem.name }}</span>
									</div>
									}
								</div>
							</div>
							}
							<mwl-calendar-week-view #calendarWeekViewComponent [viewDate]="viewDate" [events]="events"
								[refresh]="refresh" [weekendDays]="[0]" [weekStartsOn]="1"
								[hourSegmentTemplate]="hourSegmentTemplate" [eventTemplate]="eventTemplateWeek"
								[dayStartHour]="dayStartHour" [dayEndHour]="dayEndHour"
								[headerTemplate]="headerTemplate" [hourSegments]="hourSegmentsWeekView"
								[hourDuration]="hourDurationWeekView" [hourSegmentHeight]="hourSegmentHeightWeekView"
								[minimumEventHeight]="minimumEventHeightWeekView">
							</mwl-calendar-week-view>
						</div>
					</div>
					@if (navbar.hasRosterAccess()){
					<div class="col-3">
						<div class="card mb-0">
							<div class="card-header py-1 px-1 my-0">
								<h5 class="card-title mb-0 text-center">
									Employees
								</h5>
							</div>
							<div class="card-body px-2 py-1 employee-list">
								<a class="btn btn-sm btn-primary w-100" [routerLink]="['/app/roster-scheduler']">
									<fa-icon [icon]="['fas','calendar']"></fa-icon>
									Roster Scheduler
								</a>
								<div class="ng-select-default">
									<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
										placeholder="Department" [(ngModel)]="filters.department_roster"
										id="department_roster" appendTo="body"
										(change)="refreshCalendar();getUserList()" appearance="outline"
										[disabled]="disableDepartment" class="bottom-margin mt-2">
									</ng-select>
								</div>
								<table class="table table-bordered employee-table">
									<thead>
										<tr>
											<th class="name">
												Name
											</th>
											<th class="action"></th>
										</tr>
									</thead>
									<tbody>
										@for (emp of userList; track $index) {
										<tr>
											<td>
												{{emp.full_name}}
											</td>
											<td>
												<button class="btn btn-xs"
													[ngStyle]="{'background-color':emp.color||'#000000'}"
													matTooltip="Change color" (click)="openColorModal(emp)">
													&nbsp;&nbsp;&nbsp;
												</button>
												<button class="btn btn-xs btn-primary ms-2"
													(click)="createRoster(emp.emp_code)" matTooltip="Add Roster">
													<fa-icon [icon]="['fas','plus']"></fa-icon>
												</button>
											</td>
										</tr>
										}@empty {
										<tr>
											<td colspan="2" class="text-center">
												No records found
											</td>
										</tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
					}
				</ng-container>
			</div>
		</ng-container>
		}
	</div>
</div>
<ng-template #hourSegmentTemplate let-segment="segment" let-locale="locale" let-segmentHeight="segmentHeight"
	let-isTimeLabel="isTimeLabel">
	<div class="cal-hour-segment-custom"
		[ngClass]="segment.date.getHours() < 12 ? 'morning-segment' : 'afternoon-segment'"
		[style.height.px]="segmentHeight">
		@if (isTimeLabel) {
		<div class="cal-time">
			{{ segment.date | calendarDate:'weekViewHour':locale }}
		</div>
		}
	</div>
</ng-template>
<!-- <ng-template #eventTemplateWeek let-weekEvent="weekEvent">
	<ng-template #tooltip_weekview>
		<p class="mb-0">
			<strong>
				{{weekEvent.event.meta.timing.in_date}}
				{{weekEvent.event.meta.timing.in_time}}
			</strong>
		</p>
		<p class="mb-0">
			<strong>To</strong>
		</p>
		<p class="mb-0">
			<strong>
				{{weekEvent.event.meta.timing.out_date}}
				{{weekEvent.event.meta.timing.out_time}}
			</strong>
		</p>
	</ng-template>
	<div class="cust-week-event"
		[ngStyle]="{'background-color':weekEvent.event.color?.primary,'color':getContrastingTextColor(weekEvent.event.color?.primary)}"
		[ngbPopover]="tooltip_weekview" [popoverClass]="'roster-popover'" [popoverTitle]="weekEvent.event.title"
		triggers="mouseenter:mouseleave" container="body">
		<strong style="font-size: smaller;">{{getInitials(weekEvent.event.title)}}</strong>
	</div>
</ng-template> -->
<!-- <ng-template #eventTemplateWeek let-weekEvent="weekEvent">
	<div class="cal-event-custom h-100 position-relative d-flex align-items-center justify-content-center"
		[style.backgroundColor]="weekEvent.event.color?.secondary"
		[style.borderLeftColor]="weekEvent.event.color?.primary" [ngbPopover]="popoverContent"
		triggers="mouseenter:mouseleave" container="body" placement="auto">
		<div class="initial-badge-wrapper">
			<span class="initial-badge" [style.backgroundColor]="weekEvent.event.color?.primary">
				{{ weekEvent.event.meta?.userInitial }}
			</span>
		</div>
		<ng-template #popoverContent>
			<div class="p-1 text-center">
				<div class="fw-bold text-dark mb-1">{{ weekEvent.event.title }}</div>
				<div class="badge bg-light text-dark border">
					{{ weekEvent.event.start | date:'dd-MM-YYYY HH:mm' }}
				</div>
				To
				<div class="badge bg-light text-dark border">
					{{ weekEvent.event.end | date:'dd-MM-YYYY HH:mm' }}
				</div>
			</div>
		</ng-template>
	</div>
</ng-template> -->
<ng-template #eventTemplateWeek let-weekEvent="weekEvent">
	<div class="cal-event-custom h-100 position-relative d-flex flex-column align-items-center justify-content-around"
		[style.backgroundColor]="weekEvent.event.color?.secondary"
		[style.borderLeftColor]="weekEvent.event.color?.primary" [ngbPopover]="popoverContent"
		triggers="mouseenter:mouseleave" container="body" placement="auto">
		@for (item of getRepeatedBadges(weekEvent.event); track $index) {
		<span class="event-text" [class.invisible]="!item.visible" [style.color]="weekEvent.event.color?.primary">
			{{ item.text }}
		</span>
		}
		<ng-template #popoverContent>
			<div class="p-1 text-center">
				<div class="fw-bold text-dark mb-1">{{ weekEvent.event.title }}</div>
				<div class="badge bg-light text-dark border">
					{{ weekEvent.event.start | date:'dd-MM-YYYY HH:mm' }}
				</div>
				To
				<div class="badge bg-light text-dark border">
					{{ weekEvent.event.end | date:'dd-MM-YYYY HH:mm' }}
				</div>
			</div>
		</ng-template>
	</div>
</ng-template>
<ng-template #cellTemplate let-day="day">
	<div class="custom-cell" [ngClass]="[day.inMonth?'':'not-in-month']">
		<div class="row g-0">
			<div class="col">
				@if(filters.emp_code && day.inMonth){
				@if(!isFuture(day.date)){
				<p [ngbPopover]="day.events.length?popContent:null" [attr.role]="day.events.length?'button':''">
					@if(isPresent(day.events)){
					<span class="badge bg-present">
						Present
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}@else if(isOnLeave(day.events)){
					<span class="badge bg-absent">
						On Leave
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}@else if(isWorkFromHome(day.events)){
					<span class="badge bg-present" matTooltip="Work From Home">
						WFH
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}@else {
					@if(day.isWeekend || isWeeklyOff(day.events)){
					<span class="badge bg-weekly-off">
						Weekly Off
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}@else{
					@if(isHoliday(day.events)){
					<span class="badge bg-holiday" matTooltip="{{getHolidayName(day.events)}}">
						Holiday
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}@else{
					<span class="badge bg-absent">
						Absent
						<ng-container *ngTemplateOutlet="icontemplate; context: { $implicit: day }">
						</ng-container>
					</span>
					}
					}
					}
					<ng-template #icontemplate let-day>
						@if(day.events.length && day.events[0].meta.is_regularize){
						<fa-icon [icon]="['fas','user-check']" matTooltip="Regularization done"></fa-icon>
						}@else if(day.events.length && day.events[0].meta.regularize_request_sent){
						<fa-icon [icon]="['fas','user-clock']" matTooltip="Regularization requested"></fa-icon>
						}
					</ng-template>
				</p>
				}@else if(isFuture(day.date)){
				@if(isOnLeave(day.events)){
				<p>
					<span class="badge bg-absent">
						On Leave
					</span>
				</p>
				}@else if(isHoliday(day.events)){
				<p>
					<span class="badge bg-holiday" matTooltip="{{getHolidayName(day.events)}}">
						Holiday
					</span>
				</p>
				}
				}
				}@else if(!filters.emp_code){
				@if(day.events && day.events.length && day.events[0].meta.emp_list){
				@for (emp of day.events[0].meta.emp_list | slice: 0 : onLeaveListLength; track $index) {
				<p class="mb-0" matTooltip="On leave: {{emp}}">
					<span class="badge bg-absent">
						{{getInitials(emp)}}
					</span>
				</p>
				}
				@if (day.events[0].meta.emp_list.length > onLeaveListLength) {
				<span class="text-primary small" role="button"
					(click)="showListInPopup(day.events[0].meta.emp_list,day.date)">
					Show all
				</span>
				}
				}
				}
			</div>
			<div class="col">
				<div class="date"
					[ngClass]="[day.isWeekend?'text-danger':'',isToday(day.date)?'bg-primary text-light':'']">
					{{day.date.getDate()}}
				</div>
			</div>
		</div>
		@if(filters.emp_code && day.inMonth){
		<div class="row g-0">
			<div class="col">
				<p>
					@if(isPresent(day.events)){
					<!-- <span class="badge" [ngClass]="isWorkingHrsFull(day.events)?'bg-full-working':'bg-half-working'">
						{{getWorkingHrs(day.events)}}
					</span> -->
					<span class="badge" [ngClass]="getWorkingHrsColor(day.events)">
						{{getWorkingHrs(day.events)}}
					</span>
					}
				</p>
			</div>
		</div>
		<div class="row g-0">
			<div class="col">
				@if(isTaskPending(day.events)){
				<p>
					<span class="badge bg-info" role="button" [matTooltip]="'View'" (click)="viewTasks(day.events)">
						Tasks due:{{getPendingTasksCount(day.events)}}
					</span>
				</p>
				}
			</div>
			<div class="col">&nbsp;</div>
		</div>
		<div class="row g-0">
			@if(isHavingEvent(day.events)){
			<div class="col">
				<p>
					<span class="badge bg-success" role="button" matTooltip="View events attended"
						(click)="viewEvents(day.events)">
						<fa-icon [icon]="['fas','trophy']"></fa-icon>
						:
						{{getEventCount(day.events)}}
					</span>
				</p>
			</div>
			}
			@if(isHavingPresenterEvent(day.events)){
			<div class="col">
				<p>
					<span class="badge bg-success" role="button" matTooltip="View events presented"
						(click)="viewPresenterEvents(day.events)">
						P
						<fa-icon [icon]="['fas','trophy']"></fa-icon>
						:
						{{getPresenterEventCount(day.events)}}
					</span>
				</p>
			</div>
			}
		</div>
		}
	</div>
	<ng-template #popContent>
		@for (item of day.events; track $index) {
		<table class="table table-bordered">
			<thead>
				<tr>
					<th colspan="2" class="text-center">
						{{getDateString(day.date)}}
					</th>
				</tr>
				<tr>
					<th>In</th>
					<th>Out</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						{{item.meta.in_time || "-"}}
					</td>
					<td>
						{{item.meta.out_time || "-"}}
					</td>
				</tr>
				<tr>
					<td colspan="2" class="text-center">
						<button class="btn btn-xs btn-secondary" (click)="createReg(day.date)">
							Regularize
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		}
	</ng-template>
</ng-template>
<ng-template #headerTemplate let-days="days">
	<div role="row" class="cal-day-headers">
		@for (day of days; track $index) {
		<div class="cal-header"
			[ngClass]="[day.isPast?'cal-past':'',day.isToday?'bg-primary text-white':'',day.isFuture?'cal-future':'',day.isWeekend?'text-danger':'']">
			<b>{{weekDays[day.day]}}</b>
			<br />
			<label>
				{{months[day.date.getMonth()]}} {{day.date.getDate()}}
			</label>
		</div>
		}
	</div>
</ng-template>
<div class="modal fade" id="viewTasksModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">
					<strong>Tasks</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th style="width: 10% !important;">Id</th>
									<th style="width: 40% !important;">Task</th>
									<th style="width: 10% !important;">Due Date</th>
									<th style="width: 20% !important;">Assigned To</th>
									<th style="width: 20% !important;">Lead</th>
								</tr>
							</thead>
							<tbody>
								@for (item of taskList; track $index) {
								<tr>
									<td>{{item.unique_id}}</td>
									<td>{{item.sub_task}}</td>
									<td>{{item.due_date}}</td>
									<td>{{item.assigned_name}}</td>
									<td>{{item.lead_name}}</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					Ok
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="viewEventsModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">
					<strong>Events</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>Event Attended</th>
								</tr>
							</thead>
							<tbody>
								@for (item of eventList; track $index) {
								<tr>
									<td>{{item.name}}</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					Ok
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="viewPresenterEventsModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">
					<strong>Events</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-12">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>Event Presented</th>
								</tr>
							</thead>
							<tbody>
								@for (item of presenter_eventList; track $index) {
								<tr>
									<td>{{item.name}}</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
					Ok
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="colorModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-dialog-centered modal-md">
		<div class="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
			<div class="modal-header bg-light border-bottom px-4 py-3">
				<h5 class="modal-title fw-bold text-dark d-flex align-items-center">
					<fa-icon [icon]="['fas', 'palette']" class="text-primary me-2"></fa-icon>
					Assign Color
				</h5>
				<button type="button" class="btn-close shadow-none" (click)="clearColorModal();">
				</button>
			</div>
			<div class="modal-body px-4 py-4">
				<div class="text-center mb-4">
					<div class="avatar-badge bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-2 shadow-sm"
						style="width: 52px; height: 52px;">
						<fa-icon [icon]="['fas', 'user']" class="fs-4"></fa-icon>
					</div>
					<h4 class="fw-bold text-dark mb-1">
						{{colorUser?.first_name}} {{colorUser?.last_name}}
					</h4>
					<p class="text-muted small mb-0">Select a theme color for roster display</p>
				</div>

				<div class="d-flex justify-content-center">
					<div class="color-picker-container p-3 bg-light rounded-3 border shadow-sm">
						<input [style.background]="currentColor" [(colorPicker)]="currentColor"
							[cpSaveClickOutside]="true" [cpDisableInput]="true" [cpAlphaChannel]="'disabled'"
							[cpOutputFormat]="'hex'" [cpPresetColors]="presetValues" [cpToggle]="true"
							[cpDialogDisplay]="'inline'" [cpEyeDropper]="true"
							(colorPickerChange)="onColorChange($event)" style="width: 230px;" [readOnly]="true" />
					</div>
				</div>
			</div>
			<div class="modal-footer bg-light border-top px-4 py-3">
				<button type="button" class="btn btn-outline-secondary px-3" (click)="clearColorModal();">
					Cancel
				</button>
				<button type="button" class="btn btn-primary px-4" (click)="saveColor()" [disabled]="colorLoader">
					@if (colorLoader) {
					<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-1"></fa-icon>
					} @else {
					<fa-icon [icon]="['fas', 'save']" class="me-1"></fa-icon>
					}
					Save Color
				</button>
			</div>
		</div>
	</div>
</div>
<app-regularization-form [userList]="userList" (created)="refreshCalendar();getRegularizationRequests();">
</app-regularization-form>
<app-leave-form [userList]="userList" (created)="refreshCalendar();getLeaveRequests();">
</app-leave-form>
<app-roster-form [userList]="userList" (created)="refreshCalendar();">
</app-roster-form>
<app-leave-balance-form (created)="refreshCalendar();"></app-leave-balance-form>